module.exports = __webpack_public_path__ + "static/media/mercado-modelo-calendario-ima-768x591.b863bb06.jpg";